






















































import Vue from "vue";
import SingleColumn from "@/components/templates/SingleColumn.vue";
import TrialStepOs from "@/components/organisms/trial/TrialStepOs.vue";
import TrialStepRequirementsAndroid from "@/components/organisms/trial/TrialStepRequirementsAndroid.vue";
import TrialStepRequirementsWindows from "@/components/organisms/trial/TrialStepRequirementsWindows.vue";
import TrialStepDownloadAndroid from "@/components/organisms/trial/TrialStepDownloadAndroid.vue";
import TrialStepDownloadWindows from "@/components/organisms/trial/TrialStepDownloadWindows.vue";
import TrialStepActivate from "@/components/organisms/trial/TrialStepActivate.vue";

export default Vue.extend({
  name: "Trial",
  components: {
    SingleColumn,
    TrialStepOs,
    TrialStepRequirementsAndroid,
    TrialStepRequirementsWindows,
    TrialStepDownloadAndroid,
    TrialStepDownloadWindows,
    TrialStepActivate,
  },
  data() {
    return {
      step: 1,
      selectedOs: null as string | null,
    };
  },
  methods: {
    nextStep() {
      this.step = this.step + 1;
    },
    prevStep() {
      this.step = this.step - 1;
    },
  },
});
